// import { useEffect } from "react";
// import { useParams } from "react-router-dom";
// import PatientDetails from "./PatientDetails";
// import VerificationDetailsComponent from "./VerificationDetailsComponent";
// import ClaimProcesingDetails from "./ClaimProcesingDetails";
// import { getPatientDetails,getEndTime } from "../services";
// import { useMutation } from "react-query";

function ClaimProcesingComponent() {
  // const { id } = useParams();
  // const {mutate:fetchPatientDetails,data:patientDetails} = useMutation(getPatientDetails)
  // const {mutate:fetchEndTime,data:endTime} = useMutation(getEndTime)

  // useEffect(()=>{
  //   fetchPatientDetails(id)
  //   fetchEndTime(id)
  //   console.log(id);
    
  // },[id])
  return (
    <div className="flex flex-col gap-4 p-3">
      {/* <PatientDetails details={{...patientDetails,endTime}} /> */}
      {/* <VerificationDetailsComponent /> */}
      {/* <ClaimProcesingDetails/> */}
    </div>
  );
}

export default ClaimProcesingComponent;
